// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { WorkflowStepTemplateScreenResponse } from './workflow-step-template-screen-response';

/** See com.rev360.pms.api.controller.admin.encounter.WorkflowStepTemplateResponse */
/* istanbul ignore next */
@GandalfModel
export class WorkflowStepTemplateResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	displayOrder!: number | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: Number })
	workflowStepTemplateId!: number | null;

	@GandalfArray(WorkflowStepTemplateScreenResponse)
	workflowStepTemplateScreens!: WorkflowStepTemplateScreenResponse[] | null;

	@GandalfProperty({ designType: Number })
	workflowTemplateStepId!: number | null;

}
